import ServerUploadedPassengerInterface from '../../interfaces/server/UploadedPassenger'

export const UPLOAD_PASSENGERS = 'UPLOAD_PASSENGERS'

export default (passengers: ServerUploadedPassengerInterface[], selectedFlightIds: string) => ({
  type: UPLOAD_PASSENGERS,
  passengers,
  selectedFlightIds,
})
